import { useMemo } from 'react';
import { LinearProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Flex, Text } from '../../../../Components/Base';

interface LoLExaminationProgressBarProps {
  currentProgress: number;
  leftQuestionCount: number;
}

const LoLExaminationProgressBar = ({
  currentProgress,
  leftQuestionCount,
}: LoLExaminationProgressBarProps) => {
  const { t } = useTranslation('lolExamroom');
  const safeProgress = useMemo(() => {
    return Math.min(Math.round(currentProgress), 100);
  }, [currentProgress]);
  return (
    <Flex flexDirection={'column'} gap={1} p={2}>
      <Flex
        gap={1}
        alignItems={'center'}
        justifyContent={'space-between'}
        color="lolText.secondary"
      >
        <Text variant="body2">{safeProgress}%</Text>
        <Text variant="body2">{t('LEFT_QUESTION_COUNT', { count: leftQuestionCount })}</Text>
      </Flex>
      <LinearProgress
        variant="determinate"
        value={safeProgress}
        sx={{ height: '12px' }}
        color="primary"
      />
    </Flex>
  );
};

export default LoLExaminationProgressBar;
